import React, { useState } from 'react';
import { FiMail, FiPhone, FiMapPin, FiSend, FiCheckCircle, FiLinkedin, FiArrowRight, FiCalendar } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import './ContactPage.css';

const ContactPage = () => {
  const [form, setForm] = useState({
    name: '',
    email: '',
    company: '',
    budget: '',
    message: '',
  });
  const [status, setStatus] = useState({ state: 'idle', message: '' });

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus({ state: 'sending', message: '' });

    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ kind: 'contact', ...form }),
      });
      if (res.ok) {
        setStatus({ state: 'success', message: 'Thanks — we will reply within one business day.' });
        setForm({ name: '', email: '', company: '', budget: '', message: '' });
        return;
      }
      throw new Error('send failed');
    } catch {
      const subject = encodeURIComponent(`Project inquiry from ${form.name || 'website visitor'}`);
      const body = encodeURIComponent(
        `Name: ${form.name}\nEmail: ${form.email}\nCompany: ${form.company}\nBudget: ${form.budget}\n\nMessage:\n${form.message}`
      );
      window.location.href = `mailto:thinkingworld813@gmail.com?subject=${subject}&body=${body}`;
      setStatus({ state: 'fallback', message: 'Opening your email client…' });
    }
  };

  return (
    <>
      <SeoHead title="Contact us" description="Have a question or a project in mind? Reach out — we will respond within 24 hours." path="/contact" />

      <header className="page-header contact-header">
        <div className="container">
          <span className="chip"><span className="chip-dot" /> Get in touch</span>
          <h1>Let's turn your website into a sales machine.</h1>
          <p>Have a question or a project in mind? Reach out — we will respond within 24 hours.</p>
        </div>
      </header>

      <section className="section">
        <div className="container contact-grid">
          <div className="contact-info">
            <h2>Contact information</h2>
            <p>Prefer to reach out directly? Here is how to find us.</p>

            <div className="contact-cards">
              <a href="mailto:thinkingworld813@gmail.com" className="contact-card">
                <div className="contact-card-icon"><FiMail /></div>
                <div>
                  <span>Email</span>
                  <strong>thinkingworld813@gmail.com</strong>
                </div>
              </a>
              <a href="tel:+919597965911" className="contact-card">
                <div className="contact-card-icon"><FiPhone /></div>
                <div>
                  <span>Call / WhatsApp</span>
                  <strong>+91 95979 65911</strong>
                </div>
              </a>
              <a href="https://www.linkedin.com/company/thinkingworld" target="_blank" rel="noopener noreferrer" className="contact-card">
                <div className="contact-card-icon"><FiLinkedin /></div>
                <div>
                  <span>LinkedIn</span>
                  <strong>linkedin.com/company/thinkingworld</strong>
                </div>
              </a>
              <div className="contact-card contact-card--static">
                <div className="contact-card-icon"><FiMapPin /></div>
                <div>
                  <span>Based in</span>
                  <strong>Tamil Nadu, India · Working remotely</strong>
                </div>
              </div>
            </div>

            <div className="contact-promise">
              <FiCheckCircle />
              <span>
                <strong>Reply within 1 business day.</strong> Whether you have a tight brief or a fuzzy idea, we will come back with concrete questions and a path forward.
              </span>
            </div>

            <Link to="/schedule" className="btn btn-dark contact-schedule">
              <FiCalendar /> Or just schedule a meeting <FiArrowRight />
            </Link>
          </div>

          <form className="contact-form" onSubmit={handleSubmit}>
            <h3>Send us a message</h3>
            <p className="contact-form-lead">Fill out the form and our team will get back to you within 24 hours.</p>

            <div className="contact-row">
              <label>
                <span>Name *</span>
                <input type="text" required value={form.name} onChange={update('name')} placeholder="Your full name" />
              </label>
              <label>
                <span>Email *</span>
                <input type="email" required value={form.email} onChange={update('email')} placeholder="your.email@example.com" />
              </label>
            </div>

            <div className="contact-row">
              <label>
                <span>Company</span>
                <input type="text" value={form.company} onChange={update('company')} placeholder="Optional" />
              </label>
              <label>
                <span>Estimated budget</span>
                <select value={form.budget} onChange={update('budget')}>
                  <option value="">Select range</option>
                  <option>Under ₹1 Lakh</option>
                  <option>₹1L – ₹3L</option>
                  <option>₹3L – ₹10L</option>
                  <option>₹10L+</option>
                  <option>Not sure yet</option>
                </select>
              </label>
            </div>

            <label className="contact-row-full">
              <span>What are you trying to build? *</span>
              <textarea
                required
                rows="5"
                value={form.message}
                onChange={update('message')}
                placeholder="Briefly describe the product, who it is for, and any timeline or constraints we should know about."
              />
            </label>

            <button type="submit" className="btn btn-accent contact-submit" disabled={status.state === 'sending'}>
              {status.state === 'sending' ? 'Sending…' : (<>Send message <FiSend /></>)}
            </button>

            {status.state === 'success' && (
              <p className="contact-status contact-status--ok"><FiCheckCircle /> {status.message}</p>
            )}
            {status.state === 'fallback' && (
              <p className="contact-status contact-status--info">{status.message}</p>
            )}

            <p className="contact-disclaimer">
              By sending, you agree to be contacted by THINKINGWORLD about your inquiry. We will never share your details.
            </p>
          </form>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
